const BuildFileUrl = (id) => `${process.env.REACT_APP_FILE_URL}/${id}`

export default BuildFileUrl
